/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export enum Type {
  POSADJ = "POSADJ",
  NEGADJ = "NEGADJ",
}


export enum CustomsStatus {
  BONDED = "BONDED",
  NON_BONDED = "NON_BONDED",
}


export type MutationAPIResponse = {
  __typename: "MutationAPIResponse",
  message?: string | null,
  success?: boolean | null,
  timestamp?: string | null,
};

export type EntryContextUpdate = {
  entryContextKey?: string | null,
  material?: string | null,
  size?: string | null,
  countryOfOrigin?: string | null,
  quality?: string | null,
  beforeDeterminedUnitPrice?: number | null,
  afterDeterminedUnitPrice?: number | null,
};

export type MutationAPIResponseV2 = {
  __typename: "MutationAPIResponseV2",
  status?: Status | null,
  error?: Error | null,
};

export enum Status {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
}


export type Error = {
  __typename: "Error",
  message?: string | null,
};

export enum ReportType {
  STOCK = "STOCK",
}


export type AuditTransactionConnection = {
  __typename: "AuditTransactionConnection",
  items?:  Array<AuditTransaction | null > | null,
  nextToken?: string | null,
};

export type AuditTransaction = {
  __typename: "AuditTransaction",
  id: string,
  createdTimestamp?: string | null,
  commandId?: string | null,
  material?: string | null,
  size?: string | null,
  countryOfOrigin?: string | null,
  quality?: string | null,
  location?: string | null,
  transactionType?: string | null,
  action?: string | null,
  bondedQuantity?: number | null,
  nonBondedQuantity?: number | null,
  flowId?: string | null,
  businessReference?: string | null,
  source?: string | null,
  comment?: string | null,
  reason?: string | null,
  trigger?: string | null,
  flowType?: string | null,
  detail?: string | null,
};

export type AuditInventoryConnection = {
  __typename: "AuditInventoryConnection",
  items?:  Array<AuditInventory | null > | null,
  nextToken?: string | null,
};

export type AuditInventory = {
  __typename: "AuditInventory",
  material: string,
  size: string,
  countryOfOrigin: string,
  quality: string,
  location: string,
  bondedQuantity?: number | null,
  nonBondedQuantity?: number | null,
  snapshotDiff?: number | null,
  lastSuccessWmsSnapshotQuantity1060?: number | null,
  lastSuccessWmsSnapshotTimestamp1060?: string | null,
  lastSuccessWmsSnapshotQuantity1065?: number | null,
  lastSuccessWmsSnapshotTimestamp1065?: string | null,
  lastSuccessWmsSnapshotQuantity1067?: number | null,
  lastSuccessWmsSnapshotTimestamp1067?: string | null,
  lastSuccessWmsSnapshotQuantity1064?: number | null,
  lastSuccessWmsSnapshotTimestamp1064?: string | null,
  lastSuccessWmsSnapshotQuantity1264?: number | null,
  lastSuccessWmsSnapshotTimestamp1264?: string | null,
  lastSuccessLedgerSnapshotTimestamp?: string | null,
  lastSuccessLedgerSnapshotQuantity?: number | null,
  wmsSnapshotQuantity?: number | null,
  ledgerSnapshotQuantity?: number | null,
  ledgerSnapshotTimestamp?: string | null,
  balancingTimestamp?: string | null,
};

export type EntryContextConnection = {
  __typename: "EntryContextConnection",
  items?:  Array<EntryContext | null > | null,
  nextToken?: string | null,
};

export type EntryContext = {
  __typename: "EntryContext",
  entryContextKey?: string | null,
  material?: string | null,
  size?: string | null,
  mco?: string | null,
  quality?: string | null,
  determinedUnitPrice?: string | null,
  calculationTimestamp?: string | null,
  entryTriggerType?: string | null,
  entryTimestamp?: string | null,
  flowId?: string | null,
};

export type ListTransactionsFieldConnection = {
  __typename: "ListTransactionsFieldConnection",
  items?: Array< string | null > | null,
};

export type InventoryReportsConnection = {
  __typename: "InventoryReportsConnection",
  reportS3Bucket?: string | null,
  reportRegion?: string | null,
  balancingReports?:  Array<InventoryReports | null > | null,
  stockReports?:  Array<InventoryReports | null > | null,
  stockContainerBolReports?:  Array<InventoryReports | null > | null,
};

export type InventoryReports = {
  __typename: "InventoryReports",
  location?: string | null,
  reports?:  Array<InventoryReport | null > | null,
};

export type InventoryReport = {
  __typename: "InventoryReport",
  path?: string | null,
  version?: string | null,
};

export type Dashboard = {
  __typename: "Dashboard",
  unitsCreated:  Array<UnitsType | null >,
  unitsRemoved:  Array<UnitsType | null >,
  manualCorrections:  Array<ManualCorrections | null >,
  insufficientInventoryCreated:  Array<InsufficientInventoryCreated | null >,
  unexpectedReceipts:  Array<UnexpectedReceipts | null >,
  alternativeDeterminationEntries:  Array<AlternativeDeterminationEntries | null >,
  amountOfFallbackEntriesPerTrigger:  Array<AmountOfFallbackEntriesPerTrigger | null >,
  dutiesSaved:  Array<DutiesSaved | null >,
  dutiesLiabilityIndication:  Array<DutiesLiabilityIndication | null >,
  dutiesSavedNetting:  Array<DutiesSavedNetting | null >,
};

export type UnitsType = {
  __typename: "UnitsType",
  year?: string | null,
  month?: string | null,
  trigger?: string | null,
  actualCustomsStatus?: string | null,
  totalAmount?: number | null,
};

export type ManualCorrections = {
  __typename: "ManualCorrections",
  year?: string | null,
  month?: string | null,
  customsStatus?: string | null,
  action?: string | null,
  numberOfUnits?: number | null,
};

export type InsufficientInventoryCreated = {
  __typename: "InsufficientInventoryCreated",
  year?: string | null,
  month?: string | null,
  customsStatus?: string | null,
  triggeredBy?: string | null,
  numberOfUnits?: number | null,
};

export type UnexpectedReceipts = {
  __typename: "UnexpectedReceipts",
  year?: string | null,
  month?: string | null,
  action?: string | null,
  customsStatus?: string | null,
  numberOfUnits?: number | null,
};

export type AlternativeDeterminationEntries = {
  __typename: "AlternativeDeterminationEntries",
  year?: string | null,
  month?: string | null,
  alternativeValuationMethod?: string | null,
  numberOfEntries?: number | null,
  numberOfUnits?: number | null,
};

export type AmountOfFallbackEntriesPerTrigger = {
  __typename: "AmountOfFallbackEntriesPerTrigger",
  year?: string | null,
  month?: string | null,
  trigger?: string | null,
  customsStatus?: string | null,
  numberOfEntries?: number | null,
  numberOfUnits?: number | null,
};

export type DutiesSaved = {
  __typename: "DutiesSaved",
  year?: string | null,
  month?: string | null,
  dutiesSaved?: number | null,
  dutiesUsed?: number | null,
};

export type DutiesLiabilityIndication = {
  __typename: "DutiesLiabilityIndication",
  location?: string | null,
  dutiesUsed?: number | null,
  dutyLiabilityIndication?: number | null,
};

export type DutiesSavedNetting = {
  __typename: "DutiesSavedNetting",
  year?: string | null,
  month?: string | null,
  dutiesUsed?: number | null,
  dutiesSaved?: number | null,
  units?: number | null,
};

export type SubmitManualAdjustmentMutationVariables = {
  material?: string | null,
  size?: string | null,
  countryOfOrigin?: string | null,
  quality?: string | null,
  location?: string | null,
  type?: Type | null,
  quantity?: number | null,
  customsStatus?: CustomsStatus | null,
  reason?: string | null,
  comment?: string | null,
  clearGoodsIfNeeded?: boolean | null,
};

export type SubmitManualAdjustmentMutation = {
  submitManualAdjustment?:  {
    __typename: "MutationAPIResponse",
    message?: string | null,
    success?: boolean | null,
    timestamp?: string | null,
  } | null,
};

export type SubmitManualDrsOrTransitAdjustmentMutationVariables = {
  material?: string | null,
  size?: string | null,
  countryOfOrigin?: string | null,
  quality?: string | null,
  location?: string | null,
  type?: Type | null,
  quantity?: number | null,
  customsStatus?: CustomsStatus | null,
  reason?: string | null,
  comment?: string | null,
  container?: string | null,
  bol?: string | null,
  clearGoodsIfNeeded?: boolean | null,
};

export type SubmitManualDrsOrTransitAdjustmentMutation = {
  submitManualDrsOrTransitAdjustment?:  {
    __typename: "MutationAPIResponse",
    message?: string | null,
    success?: boolean | null,
    timestamp?: string | null,
  } | null,
};

export type SubmitEntryContextUpdateMutationVariables = {
  entryContextUpdates: Array< EntryContextUpdate >,
};

export type SubmitEntryContextUpdateMutation = {
  submitEntryContextUpdate?:  {
    __typename: "MutationAPIResponseV2",
    status?: Status | null,
    error?:  {
      __typename: "Error",
      message?: string | null,
    } | null,
  } | null,
};

export type SubmitCreateInventoryReportMutationVariables = {
  reportType?: ReportType | null,
};

export type SubmitCreateInventoryReportMutation = {
  submitCreateInventoryReport?:  {
    __typename: "MutationAPIResponse",
    message?: string | null,
    success?: boolean | null,
    timestamp?: string | null,
  } | null,
};

export type TransactionsDynamicSearchQueryVariables = {
  material: string,
  size: string,
  countryOfOrigin: string,
  quality: string,
  fromTimestamp?: number | null,
  toTimestamp?: number | null,
  type?: string | null,
  location?: string | null,
  customsStatus?: string | null,
  reason?: string | null,
  source?: string | null,
  nextToken?: string | null,
};

export type TransactionsDynamicSearchQuery = {
  transactionsDynamicSearch?:  {
    __typename: "AuditTransactionConnection",
    items?:  Array< {
      __typename: "AuditTransaction",
      id: string,
      createdTimestamp?: string | null,
      commandId?: string | null,
      material?: string | null,
      size?: string | null,
      countryOfOrigin?: string | null,
      quality?: string | null,
      location?: string | null,
      transactionType?: string | null,
      action?: string | null,
      bondedQuantity?: number | null,
      nonBondedQuantity?: number | null,
      flowId?: string | null,
      businessReference?: string | null,
      source?: string | null,
      comment?: string | null,
      reason?: string | null,
      trigger?: string | null,
      flowType?: string | null,
      detail?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type InventoryDynamicSearchQueryVariables = {
  material?: string | null,
  size?: string | null,
  countryOfOrigin?: string | null,
  quality?: string | null,
  imbalanceFilter?: string | null,
  nextToken?: string | null,
};

export type InventoryDynamicSearchQuery = {
  inventoryDynamicSearch?:  {
    __typename: "AuditInventoryConnection",
    items?:  Array< {
      __typename: "AuditInventory",
      material: string,
      size: string,
      countryOfOrigin: string,
      quality: string,
      location: string,
      bondedQuantity?: number | null,
      nonBondedQuantity?: number | null,
      snapshotDiff?: number | null,
      lastSuccessWmsSnapshotQuantity1060?: number | null,
      lastSuccessWmsSnapshotTimestamp1060?: string | null,
      lastSuccessWmsSnapshotQuantity1065?: number | null,
      lastSuccessWmsSnapshotTimestamp1065?: string | null,
      lastSuccessWmsSnapshotQuantity1067?: number | null,
      lastSuccessWmsSnapshotTimestamp1067?: string | null,
      lastSuccessWmsSnapshotQuantity1064?: number | null,
      lastSuccessWmsSnapshotTimestamp1064?: string | null,
      lastSuccessWmsSnapshotQuantity1264?: number | null,
      lastSuccessWmsSnapshotTimestamp1264?: string | null,
      lastSuccessLedgerSnapshotTimestamp?: string | null,
      lastSuccessLedgerSnapshotQuantity?: number | null,
      wmsSnapshotQuantity?: number | null,
      ledgerSnapshotQuantity?: number | null,
      ledgerSnapshotTimestamp?: string | null,
      balancingTimestamp?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type EntryContextFallbackSearchQueryVariables = {
};

export type EntryContextFallbackSearchQuery = {
  entryContextFallbackSearch?:  {
    __typename: "EntryContextConnection",
    items?:  Array< {
      __typename: "EntryContext",
      entryContextKey?: string | null,
      material?: string | null,
      size?: string | null,
      mco?: string | null,
      quality?: string | null,
      determinedUnitPrice?: string | null,
      calculationTimestamp?: string | null,
      entryTriggerType?: string | null,
      entryTimestamp?: string | null,
      flowId?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type InventoryDetailSearchQueryVariables = {
  material: string,
  size: string,
  countryOfOrigin: string,
  quality: string,
};

export type InventoryDetailSearchQuery = {
  inventoryDetailSearch?:  {
    __typename: "AuditInventoryConnection",
    items?:  Array< {
      __typename: "AuditInventory",
      material: string,
      size: string,
      countryOfOrigin: string,
      quality: string,
      location: string,
      bondedQuantity?: number | null,
      nonBondedQuantity?: number | null,
      snapshotDiff?: number | null,
      lastSuccessWmsSnapshotQuantity1060?: number | null,
      lastSuccessWmsSnapshotTimestamp1060?: string | null,
      lastSuccessWmsSnapshotQuantity1065?: number | null,
      lastSuccessWmsSnapshotTimestamp1065?: string | null,
      lastSuccessWmsSnapshotQuantity1067?: number | null,
      lastSuccessWmsSnapshotTimestamp1067?: string | null,
      lastSuccessWmsSnapshotQuantity1064?: number | null,
      lastSuccessWmsSnapshotTimestamp1064?: string | null,
      lastSuccessWmsSnapshotQuantity1264?: number | null,
      lastSuccessWmsSnapshotTimestamp1264?: string | null,
      lastSuccessLedgerSnapshotTimestamp?: string | null,
      lastSuccessLedgerSnapshotQuantity?: number | null,
      wmsSnapshotQuantity?: number | null,
      ledgerSnapshotQuantity?: number | null,
      ledgerSnapshotTimestamp?: string | null,
      balancingTimestamp?: string | null,
    } | null > | null,
    nextToken?: string | null,
  } | null,
};

export type ListTransactionsFieldSearchQueryVariables = {
  fieldName?: string | null,
};

export type ListTransactionsFieldSearchQuery = {
  listTransactionsFieldSearch?:  {
    __typename: "ListTransactionsFieldConnection",
    items?: Array< string | null > | null,
  } | null,
};

export type GetInventoryQuantityBySkuContainerBolQueryVariables = {
  material?: string | null,
  size?: string | null,
  countryOfOrigin?: string | null,
  quality?: string | null,
  container?: string | null,
  bol?: string | null,
};

export type GetInventoryQuantityBySkuContainerBolQuery = {
  getInventoryQuantityBySkuContainerBol?: string | null,
};

export type GetInventoryReportsQueryVariables = {
};

export type GetInventoryReportsQuery = {
  getInventoryReports?:  {
    __typename: "InventoryReportsConnection",
    reportS3Bucket?: string | null,
    reportRegion?: string | null,
    balancingReports?:  Array< {
      __typename: "InventoryReports",
      location?: string | null,
      reports?:  Array< {
        __typename: "InventoryReport",
        path?: string | null,
        version?: string | null,
      } | null > | null,
    } | null > | null,
    stockReports?:  Array< {
      __typename: "InventoryReports",
      location?: string | null,
      reports?:  Array< {
        __typename: "InventoryReport",
        path?: string | null,
        version?: string | null,
      } | null > | null,
    } | null > | null,
    stockContainerBolReports?:  Array< {
      __typename: "InventoryReports",
      location?: string | null,
      reports?:  Array< {
        __typename: "InventoryReport",
        path?: string | null,
        version?: string | null,
      } | null > | null,
    } | null > | null,
  } | null,
};

export type GetDashboardQueryVariables = {
};

export type GetDashboardQuery = {
  getDashboard?:  {
    __typename: "Dashboard",
    unitsCreated:  Array< {
      __typename: "UnitsType",
      year?: string | null,
      month?: string | null,
      trigger?: string | null,
      actualCustomsStatus?: string | null,
      totalAmount?: number | null,
    } | null >,
    unitsRemoved:  Array< {
      __typename: "UnitsType",
      year?: string | null,
      month?: string | null,
      trigger?: string | null,
      actualCustomsStatus?: string | null,
      totalAmount?: number | null,
    } | null >,
    manualCorrections:  Array< {
      __typename: "ManualCorrections",
      year?: string | null,
      month?: string | null,
      customsStatus?: string | null,
      action?: string | null,
      numberOfUnits?: number | null,
    } | null >,
    insufficientInventoryCreated:  Array< {
      __typename: "InsufficientInventoryCreated",
      year?: string | null,
      month?: string | null,
      customsStatus?: string | null,
      triggeredBy?: string | null,
      numberOfUnits?: number | null,
    } | null >,
    unexpectedReceipts:  Array< {
      __typename: "UnexpectedReceipts",
      year?: string | null,
      month?: string | null,
      action?: string | null,
      customsStatus?: string | null,
      numberOfUnits?: number | null,
    } | null >,
    alternativeDeterminationEntries:  Array< {
      __typename: "AlternativeDeterminationEntries",
      year?: string | null,
      month?: string | null,
      alternativeValuationMethod?: string | null,
      numberOfEntries?: number | null,
      numberOfUnits?: number | null,
    } | null >,
    amountOfFallbackEntriesPerTrigger:  Array< {
      __typename: "AmountOfFallbackEntriesPerTrigger",
      year?: string | null,
      month?: string | null,
      trigger?: string | null,
      customsStatus?: string | null,
      numberOfEntries?: number | null,
      numberOfUnits?: number | null,
    } | null >,
    dutiesSaved:  Array< {
      __typename: "DutiesSaved",
      year?: string | null,
      month?: string | null,
      dutiesSaved?: number | null,
      dutiesUsed?: number | null,
    } | null >,
    dutiesLiabilityIndication:  Array< {
      __typename: "DutiesLiabilityIndication",
      location?: string | null,
      dutiesUsed?: number | null,
      dutyLiabilityIndication?: number | null,
    } | null >,
    dutiesSavedNetting:  Array< {
      __typename: "DutiesSavedNetting",
      year?: string | null,
      month?: string | null,
      dutiesUsed?: number | null,
      dutiesSaved?: number | null,
      units?: number | null,
    } | null >,
  } | null,
};
